import AboutDescription from "./AboutDescription";
import AboutUsSectionItem from "./AboutItem";

const AboutLayout = ({ cards, description }) => {

    return (
        <div className="aboutus-section-rows">
            <AboutDescription description={description} />
            {
                cards?.map((item, index) => (
                    <AboutUsSectionItem key={index} data={item} />
                ))
            }
        </div>
    );
}

export default AboutLayout;
